export default __webpack_public_path__ + "static/media/large-frame-bg1.5fc03e58.svg";